import setNavigation from "./components/navigation";
import { scrollToId } from "./components/scrollToId";

(function ($) {

    setNavigation();

    $('.home .headerslider').slick({
        dots: true,
        infinite: true,
        speed: 1500,
        slidesToShow: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 541,
                settings: {
                    arrows: false,
                }
            },
        ]
    });
    $('.text_scroller').slick({
        dots: false,
        infinite: true,
        arrows: false,
        speed: 7000,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear'
    });
    $('.image_carousel').slick({
        dots: false,
        infinite: true,
        speed: 800,
        slidesToShow: 3,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });

    $('#to_top').on('click', function () {
        scrollToId('#main', 10);
    });

    $(window).on('scroll', function () {
        const fHeight = $('#colophone').outerHeight();
        const wScroll = $(document).scrollTop();
        const dBottom = document.body.clientHeight - window.innerHeight;
        const animStart = dBottom - fHeight;
        const factor = fHeight / 180;
        const deg = 170 + (wScroll - animStart) / factor;
        if (wScroll > animStart) {
            $('#colophone .circle').css({ transform: 'rotate(' + deg + 'deg)' });
        }
    });

    $("a[href^='#']").on('click', function (e) {
        e.preventDefault();
        var hash = this.hash;
        scrollToId(hash, 80);
    });

})(jQuery);